import { SvgIconProps } from './icon-props';

export default function CheckmarkOutline({
	height = 32,
	width = 32,
	fill = 'currentColor',
	className,
}: SvgIconProps) {
	return (
		<svg
			id="Icons"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 32"
			fill={fill}
			className={className}
		>
			<path d="M24.29,9.05c.43.35.5.98.15,1.41l-9.98,12.34c-.18.22-.44.35-.72.37-.02,0-.04,0-.05,0-.26,0-.52-.1-.71-.29l-5.33-5.33c-.39-.39-.39-1.02,0-1.41.39-.39,1.02-.39,1.41,0l4.54,4.54,9.29-11.47c.35-.43.98-.5,1.41-.15ZM31.5,16c0,8.55-6.95,15.5-15.5,15.5S.5,24.55.5,16,7.45.5,16,.5s15.5,6.95,15.5,15.5ZM30.5,16c0-8-6.5-14.5-14.5-14.5S1.5,8,1.5,16s6.5,14.5,14.5,14.5,14.5-6.5,14.5-14.5Z" />
		</svg>
	);
}
